/**
 * @Author: wuyang
 * @Date: 2024/1/8
 * @Description: ""
 */
import React, { FC, PropsWithChildren } from 'react'
import { Outlet } from 'react-router'

export const FullScreen: FC<PropsWithChildren<{}>> = (props) => {
	return (
		<div className="full-screen">
			<Outlet></Outlet>
		</div>
	)
}
